import { SceneWrapper } from '~/components';
import { type FormikProps, isEmpty, useFormikContext } from '~/modules';
import type { OnboardingAddressFormValues } from './schema';
import {
  ButtonComponent,
  FormLeftColumn,
  FormRightColumn,
  FormRow,
  Input,
} from './styles';

const OnboardingAddress = () => {
  const {
    values,
    errors,
    setFieldValue,
    setFieldTouched,
    submitForm,
    isValid,
    touched,
  }: FormikProps<OnboardingAddressFormValues> = useFormikContext();

  const handleFieldChange =
    (fieldName: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue(fieldName, e.target.value);
      setFieldTouched(fieldName, true, false);
    };

  const handleFieldBlur = (fieldName: string) => () => {
    setFieldTouched(fieldName, true);
  };

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="onboarding-address"
          onPress={submitForm}
          disabled={
            !isValid ||
            isEmpty(values.city) ||
            isEmpty(values.uf) ||
            isEmpty(values.street) ||
            isEmpty(values.neighborhood) ||
            isEmpty(values.cep) ||
            isEmpty(values.number)
          }
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <FormRow>
        <Input
          placeholder="00000-000"
          name="cep"
          id="cep"
          value={values.cep}
          onChange={handleFieldChange('cep')}
          onBlur={handleFieldBlur('cep')}
          label="Digite seu CEP"
          errors={touched.cep && errors?.cep}
          maskType="cep"
        />
      </FormRow>
      <FormRow>
        <FormLeftColumn width="65%">
          <Input
            name="street"
            id="street"
            value={values.street}
            onChange={handleFieldChange('street')}
            onBlur={handleFieldBlur('street')}
            label="Rua, Avenida"
            errors={touched.street && errors?.street}
          />
        </FormLeftColumn>
        <FormRightColumn width="30%">
          <Input
            name="number"
            id="number"
            value={values.number}
            onChange={handleFieldChange('number')}
            onBlur={handleFieldBlur('number')}
            label="Núm."
            errors={touched.number && errors?.number}
          />
        </FormRightColumn>
      </FormRow>
      <FormRow>
        <Input
          name="complement"
          id="complement"
          value={values.complement}
          onChange={handleFieldChange('complement')}
          onBlur={handleFieldBlur('complement')}
          label="Complemento (opcional)"
          errors={touched.complement && errors?.complement}
        />
      </FormRow>
      <FormRow>
        <Input
          name="neighborhood"
          id="neighborhood"
          value={values.neighborhood}
          onChange={handleFieldChange('neighborhood')}
          onBlur={handleFieldBlur('neighborhood')}
          label="Bairro"
          errors={touched.neighborhood && errors?.neighborhood}
        />
      </FormRow>
      <FormRow>
        <FormLeftColumn width="65%">
          <Input
            name="city"
            id="city"
            value={values.city}
            onChange={handleFieldChange('city')}
            onBlur={handleFieldBlur('city')}
            label="Cidade"
            errors={touched.city && errors?.city}
          />
        </FormLeftColumn>
        <FormRightColumn width="30%">
          <Input
            name="uf"
            id="uf"
            value={values.uf}
            onChange={handleFieldChange('uf')}
            onBlur={handleFieldBlur('uf')}
            label="UF"
            errors={touched.uf && errors?.uf}
          />
        </FormRightColumn>
      </FormRow>
    </SceneWrapper>
  );
};

export default OnboardingAddress;
